const ApiToolTips = {
    'body':'',
    'start':function(){
        let self = this;
        self.init();
        self.setTooltip();
        self.setNormalTooltip();
    },
    'setTooltip': function(){
        let self = this;
        let tooltipTriggers = self.body.find('[tooltip-trigger]');

        tooltipTriggers.each(function(){
            let tooltipTrigger = $(this)
            tooltipTrigger.on('mouseover', function(){
                console.log('tooltip');
                let onMouseOver = $(this);
                let triggerName = onMouseOver.attr('tooltip-trigger');
                let tooltipTarget = self.body.find('[tooltip-target="'+triggerName+'"]');
                let tooltipValue = onMouseOver.attr('tooltip-value');
                let items = tooltipValue.split('|');
                let html = '<div class="text-smallest text-right">'+items[0]+'</div>';
                html += '<div class="text-smallest text-right">'+items[1]+'</div>';
                tooltipTarget.html(html);
                // console.log('hover');
            });

            tooltipTrigger.on('mouseout', function() {
                let onMouseOut = $(this);
                let triggerName = onMouseOut.attr('tooltip-trigger');
                let tooltipTarget = self.body.find('[tooltip-target="'+triggerName+'"]');
                tooltipTarget.text(''); // clear text
            });
        });
    },

    'setNormalTooltip': function(){
        let self = this;
        let tooltips = self.body.find('[tooltip]');
        let tooltipTarget = self.body.find('div.tooltip');

        console.log(tooltips.length);
        console.log(tooltipTarget.length);

        tooltips.unbind('mouseover mouseout');
        tooltips.each(function(){
            let tooltip = $(this);
            tooltip.on('mouseover', function(){
                let thisMouseover = $(this);
                let tooltipValue = thisMouseover.attr('tooltip');

                tooltipTarget.html(tooltipValue);
                self.setTooltipPosition(thisMouseover);
                tooltipTarget.removeClass('hidden');
            });

            tooltip.on('mouseout', function(){
               let thisMouseOut = $(this);
                tooltipTarget.addClass('hidden');
               tooltipTarget.css('top','0').css('left','0');
            });


        });
    },
    'setTooltipPosition': function(tooltipSource){
        let self = this;
        let pos = tooltipSource.offset();
        let sWidth = tooltipSource.width();
        let sWidthHalf = (Math.floor(sWidth) * 0.5);

        let tooltipTarget = self.body.find('div.tooltip');

        let tWidth = tooltipTarget.width();
        let tHeight = tooltipTarget.outerHeight(true);
        let tWidthHalft = (tWidth * 0.5) - 2;

        tooltipTarget
            .css('top', (pos.top - (tHeight + 7)) + 'px')
            .css('left', (pos.left - tWidthHalft- sWidthHalf) + 'px');
    },

    'init':function(){
        let self = this;
        self.body = $('body');
    }
}

$(document).ready(function(){
    ApiToolTips.start();
});
